import React from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import { Divider, Grid, Typography, List, ListItem } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

// function createCurData(S1, U1, S2, U2){
//     return {S1, U1, S2, U2};
// }

// const first =[
//     createCurData('Bioinfo 201', 3, 'Bioinfo 204', 3),
//     createCurData('Bioinfo 202', 3, 'Bioinfo 205', 3),
//     createCurData('Bioinfo 203', 3, 'Bioinfo 296', 1),
//     createCurData('Elective 1', 3, 'Elective 2', 3),
// ];

// const second = [
//     createCurData('Bioinfo 271', 3, 'Bioinfo 300', 3),
//     createCurData('Bioinfo 300', 3, '', ''),
//     createCurData('Elective 3', 3, '', ''),
//     createCurData('Elective 4', 3, '', ''),
// ];

function createTwoColRow(col1, col2){
    return {col1, col2};
}

function createThreeColRow(col1, col2, col3){
    return {col1, col2, col3};
}

const core = [  
    createTwoColRow("One Theory Course", "3 units"),
    createTwoColRow("One Systems Course", "3 units"),
    createTwoColRow("One Theory or Systems Course", "3 units")
];

const required = [  
    createThreeColRow("", "Specializiation Courses", "9 units"),
    createThreeColRow("", "Graduate Electives", "6 units"),
    createThreeColRow("296", "Graduate Seminar", "1 unit"),
    createThreeColRow("400", "Dissertation ", "12 units")
];

const coretheory = [
    createThreeColRow("204 ", "Theory of Computation", "Formal models of computation; recursive function theory; undecidability. Resource-bounded computational complexity, non-determinism, NP-completeness."),
    createThreeColRow("210 ", "Advanced Algorithms and Data Structures", "Advanced data structures; algorithm design techniques; mathematical techniques in the analysis of algorithms."),
    createThreeColRow("214 ", "Parallel Algorithms", "Models of parallel computation. Performance measures, scalability, pipelining, techniques for analyzing parallel algorithms. Interconnection network topologies. Applications."),
    createThreeColRow("231 ", "Numerical Computing", "Algorithm design for numerical computation. Error analysis. Performance evaluation of numerical software."),
    createThreeColRow("360 ", "Formal Methods", ""),
]

const coresystems = [
    createThreeColRow("220 ", "Survey of Programming Languages", "Comparative study of different types of modern programming languages; imperative, functional, logic-based and object-oriented. Syntax, semantics and implementation of programming languages."),
    createThreeColRow("250 ", "Advanced Operating Systems", "Synchronization and communication mechanisms, virtual memory management,file systems, deadlock control, resource allocation, protection and access control. Case study of specialized systemsother cryptographic protocols."),
    createThreeColRow("260 ", "Advanced Software Engineering", "Structured approach to requirements analysis, system design, implementation and maintenance of software systems. Formal description and documentation techniques."),
    createThreeColRow("270 ", "Advanced Database Systems", "Data models and their underlying mathematical foundations; database manipulation and query languages; functional dependencies; physical data organization and indexing methods; concurrency control; crash recovery; database security; distributed databases."),
    createThreeColRow("253 ", "Computer Security", "Encryption, digital signatures,authentication, key management. Secure electronic commerce. Network Security. File security."),
    createThreeColRow("255 ", "Advanced Computer Networks", "The OSI Reference Model and layers. Distributed computing. Networked multimedia systems. Clint-server computing. Communication and internet working."),
    createThreeColRow("268 ", "Web Science", "The Web as a full communications medium that fosters full collaboration, social interaction, and commerce. Case studies."),
    createThreeColRow("280 ", "Intelligent Systems", "Fundamental issues in Intelligent Systems. Intelligent search and optimization methods. Knowledge representation and reasoning. Learning, natural language understanding, pattern recognition, knowledge-based systems and other methods in intelligent Systems."),
    createThreeColRow("351 ", "Pervasive Computing and Communication", ""),
    createThreeColRow("369 ", "Semantic Web", "")
]

function PHDCS() {
    return(
        <ThemeProvider theme={theme}>
        <NavbarDefault />
            <Grid         
                container
                direction="row"
                justifyContent="center"
                height="50%"
                sx={{ flexGrow: 1, 
                paddingBottom: 2,
                paddingRight: 2,
                marginTop: 2,
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 5,
                maxWidth: 1,
                alignItems: "center"
                }}
                spacing={2}
            >
                <Grid item xs={8} sx={{textAlign: 'justify'}}>
                    <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                        DOCTOR OF PHILOSOPHY IN COMPUTER SCIENCE
                    </Typography>
                    <Grid item xs={8} sx={{textAlign:'justify'}}>

                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            PROGRAM SUMMARY
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                        The program aims to develop computer scientists who are armed with methods, tools and techniques from both theoretical and systems aspects of computing. They should be able to formulate computing problems and develop new and innovative technology as novel solutions to address those problems. The graduates will gain expertise to independently contribute in Research and Development (R&D) on a specialized area of Computer Science. The program will prepare graduates for professional and/or research careers in industry, government or academe.</Typography>
                        <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            PROGRAM ADMISSIONS
                        </Typography>
                        <Typography sx = {{mt: 1}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            <i>Admission Requirements</i>
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            I. Applicants must have a master's degree in Computer Science, Electrical and Electronics Engineering, Mathematics, or other allied fields provided they have a substantial background in computing. Applicants must have a sufficient background in computing which includes the following -<br/>
                        </Typography>
                        <List>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Data Structures and Algorithms</ListItem>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Automata Theory</ListItem>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Operating Systems</ListItem>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Discrete Mathematical Structures</ListItem>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Computer Networks</ListItem>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Database Systems</ListItem>
                            <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: 0}}> <b>• </b>Software Engineering</ListItem>
                        </List>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            II. Applicants must demonstrate proficiency in at least one high-level programming language prescribed by the department's graduate committee<br/><br/>

                            III. Applicants must get endorsement from one of the department's eight research laboratories
                        </Typography>

                        <Typography sx = {{mt: 1}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            <i>Required Documents</i>
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                            I. Scanned official transcript of records of undergraduate (and graduate studies, if applicable) from all universities attended<br/><br/>
                            II. Scanned PSA Birth Certificate (for Filipino applicants) or Scanned Passport data page (for foreign applicants) <br/><br/>
                            III. Recent formal photo (preferrably passport photo)<br/><br/>
                            IV. An application fee of P100.00 for Filipino citizens, or $20.00 for resident foreign applicants to be paid through bank transfer or at the Cashier's Office, UP Diliman, Quezon City.<br/><br/>
                            V. <i>For Foreign Applicants:</i> Certification of English language proficiency - Official Test of English as a Foreign Language score report.<br/><br/>
                            VI. <i>For Non-UP Graduates:</i> Honorable Dismissal/Transfer Credentials 
                        </Typography>

                        <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

                        <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            PROGRAM COURSE STRUCTURE [37 units]
                        </Typography>

                        <Typography sx={{mt:2}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                          <i>Core Courses</i>
                        </Typography>
                        <Grid item xs={12} md={10} sx={{textAlign: 'justify'}}>
                            <TableContainer component={Paper} sx={{flexGrow:1}}>
                                <Table sx={{width:1}} aria-label='simple table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='left'><b>Course Name</b></TableCell>
                                            <TableCell align='left'><b>9 units</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {core.map((core) => (
                                            <TableRow
                                            key={core.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >   
                                                <TableCell align='left'>{core.col1}</TableCell>
                                                <TableCell align='left'>{core.col2}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Typography sx={{mt:2}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            <i>Required Courses</i>
                        </Typography>
                        <Grid item xs={12} md={10} sx={{textAlign: 'justify'}}>
                            <TableContainer component={Paper} sx={{flexGrow:1}}>
                                <Table sx={{width:1}} aria-label='simple table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='left'><b>CS</b></TableCell>
                                            <TableCell align='left'><b>Course Name</b></TableCell>
                                            <TableCell align='left'><b>28 units</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {required.map((required) => (
                                            <TableRow
                                            key={required.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell align='left'>{required.col1}</TableCell>
                                                <TableCell align='left'>{required.col2}</TableCell>
                                                <TableCell align='left'>{required.col3}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        <Typography sx = {{mt:3}} variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            COURSE OPTIONS
                        </Typography>
                        <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            <i>Core Theory Course Options</i>
                        </Typography>
                        <TableContainer component={Paper} sx={{flexGrow:1}}>
                            <Table sx={{width:1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'><b>CS</b></TableCell>
                                        <TableCell align='left'><b>Course Name</b></TableCell>
                                        <TableCell align='left'><b>Description</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {coretheory.map((coretheory) => (
                                        <TableRow
                                        key={coretheory.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{coretheory.col1}</TableCell>
                                            <TableCell align='left'>{coretheory.col2}</TableCell>
                                            <TableCell align="left">{coretheory.col3}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={4}>
                            <i>Core System Course Options</i>
                        </Typography>
                        <TableContainer component={Paper} sx={{flexGrow:1}}>
                            <Table sx={{width:1}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'><b>CS</b></TableCell>
                                        <TableCell align='left'><b>Course Name</b></TableCell>
                                        <TableCell align='left'><b>Description</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {coresystems.map((coresystems) => (
                                        <TableRow
                                        key={coresystems.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{coresystems.col1}</TableCell>
                                            <TableCell align='left'>{coresystems.col2}</TableCell>
                                            <TableCell align="left">{coresystems.col3}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Typography sx = {{mt: 5}}variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                            APPLY NOW
                        </Typography>
                        <Typography variant='b1' fontFamily="Segoe UI">
                        For the application portal visit <a href="http://ngse.upd.edu.ph/"  style={{color: '#7B1113'}}>UPD NGSE Online Application</a>. <br/>
                        <b>Deadline for Application:</b> June 30, 2023 11:59 PM<br/>
                        Classes Start August 2023<br/><br/>

                        For further inquiries you may contact DCS through <a href="mailto: info@dcs.upd.edu.ph"  style={{color: '#7B1113'}}>info@dcs.upd.edu.ph</a>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        <FooterDefault /> 
        </ThemeProvider>
    )
}

export default PHDCS

// function PHDC1S() {
//     return(
//         <div>
//         <NavbarDefault />
//             <Grid         
//                 container
//                 direction="row"
//                 justifyContent="center"
//                 height="50%"
//                 sx={{ flexGrow: 1, 
//                 paddingBottom: 2,
//                 paddingRight: 2,
//                 marginTop: 2,
//                 marginLeft: "auto",
//                 marginRight: "auto",
//                 marginBottom: 5,
//                 maxWidth: 1,
//                 alignItems: "center"
//                 }}
//                 spacing={2}
//             >
//                 <Grid item xs={8} sx={{textAlign: 'justify'}}>
//                     <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
//                             WHAT ARE THE ADMISSION REQUIREMENTS FOR GRADUATE APPLICANTS?
//                     </Typography>
//                     <Grid item xs={8} sx={{textAlign:'justify'}}>
//                         <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
//                             GRADUATE PROGRAMS
//                         </Typography>
//                         <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

//                         <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
//                             <i>Master of Science in Computer Science</i>
//                         </Typography>
//                         <Typography variant='b1' fontFamily="Segoe UI">
//                             I. Applicants must have at least a bachelor's degree in Computer Science, Engineering, Mathematics or other allied fields,which provide a substantial background in computing<br/><br/>

//                             II. Applicants must demonstrate proficiency in at least one high-level programming language prescribed by the department's graduate committee<br/><br/>

//                             III. Applicants must have a general knowledge of Computer Science. This may include but is not limited to the following:<br/>
//                         </Typography>
//                         <List>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Data Structures and Algorithms</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Theory of Computation</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Discrete Mathematical Structures</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Computer Networks</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Database Systems</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: 0}}> <b>• </b>Software Engineering</ListItem>
//                         </List>
//                         <Typography variant='b1' fontFamily="Segoe UI">
//                             IV. Applicants must get endorsement from one of the department's eight research laboratories
//                         </Typography>
//                         <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

//                         <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
//                             <i>Master of Science in Bioinformatics</i>
//                         </Typography>
//                         <Typography variant='b1' fontFamily="Segoe UI">
//                             I. Applicants must have at least a bachelor's degree in Computer Science, Engineering, Mathematics or other allied fields,which provide a substantial background in computing<br/><br/>

//                             II. Applicants must demonstrate proficiency in at least one high-level programming language prescribed by the department's graduate committee<br/><br/>

//                             III. Applicants must have a general knowledge of Computer Science. This may include but is not limited to the following:<br/>
//                         </Typography>
//                         <List>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Data Structures and Algorithms</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Theory of Computation</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Discrete Mathematical Structures</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Computer Networks</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Database Systems</ListItem>
//                             <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: 0}}> <b>• </b>Software Engineering</ListItem>
//                         </List>
//                         <Typography variant='b1' fontFamily="Segoe UI">
//                             IV. Applicants must get endorsement from one of the department's eight research laboratories
//                         </Typography>
//                         <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

//                         <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
//                             <i>Doctor of Philosophy in Computer Science</i>
//                         </Typography>
                        
//                     </Grid>
//                 </Grid>
//             </Grid>
//         <FooterDefault /> 
//         </div>
//     )
// }
